import React, { useState } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { SearchBox } from '../../../components/';
import css from './MainPanelHeader.module.css';

/**
 * MainPanelHeader component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {React.Node} props.children - The children
 * @param {React.Node} props.sortByComponent - The sort by component
 * @param {boolean} props.isSortByActive - Whether the sort by is active
 * @param {boolean} props.listingsAreLoaded - Whether the listings are loaded
 * @param {number} props.resultsCount - The results count
 * @param {boolean} props.searchInProgress - Whether the search is in progress
 * @param {React.Node} props.noResultsInfo - The no results info
 * @returns {JSX.Element}
 */

import cancelIcon from '../../../assets/cancelIcon.svg';
import { keys } from 'lodash';

function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    getHandleChangedValueFn,
    currentQueryParams,
    handleResetAll
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const [showFilter,setShowFilter] = useState(false);

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <div style={{display:"flex"}}>
        <SearchBox/>
        <div className={"filter-menu-open "+(showFilter ? "toggled":"")} onClick={()=>{setShowFilter(!showFilter);}}>
          <div className={"first"}/>
          <div className={"second"}/>
          <div className={"third"}/>
        </div>
        </div>
        <div className="filter-options">
          {keys(currentQueryParams).map((key)=>{
            if (key==null) return null;
            let val = currentQueryParams[key]; 
            let key2;
            if (val==null) return null;
            const levelCheck = key.match(/Level([0-9])/);
            if ((levelCheck)&&(levelCheck[1] != "1")) return null;
            if (levelCheck) {
              key2 = key.replace(/(.*Level)[0-9]/,"$12"); 
              if (currentQueryParams[key2]) {
                val = val + ":" + currentQueryParams[key2];
              }else{
                key2 = null;
              }
            }
            
            if (key=="sort") return null;
            if (key=="keywords") return null;
            const name = key.replace("pub_","").replaceAll(/Level[0-9]/g,"").replaceAll(/([A-Z][a-z]*)/g," $&").replace(/(^|\s|\-+)\w/g, match => match.toUpperCase());
            const value = val.replaceAll("-"," ").replaceAll(",","-").replace(/(^|\s|\-+)\w/g, match => match.toUpperCase());
            return (<div className="filter-option-button" onClick={()=>{getHandleChangedValueFn(true)(key2?{[key]:null,[key2]:null}:{[key]:null})}}>
              {name}: {value}
              <img src={cancelIcon}/>
            </div>);
          })}
          <div className="filter-option-button clear-filters"  onClick={e => handleResetAll(e)}>Clear Filters</div>
        </div>
      </div>
      {children}

      
    </div>
  );
};

export default MainPanelHeader;
